import { identity } from 'lodash-es';
import { createContext } from 'react';

const ResponsiveOverrideContext = createContext({
  mapper: identity,
});

export default ResponsiveOverrideContext;
